import { connect } from 'react-redux';
import moment from 'moment';
import { change, reset } from 'redux-form';
import {
  setSppbInfoDialogVisibility, setSppbSelectedDocType, showErrorSnackbar, uploadSppbAsync,
} from '../../redux/action';
import LocalizedString from '../../localization';
import { unauthorizedErrorHandler } from '../../helper';
import {
  MOMENT_DATE_API_FORMAT_STRING, RXFIELD_SPPB_DATE, RXFIELD_SPPB_DOC_CODE, RXFIELD_SPPB_NPWP,
  RXFORM_SPPB, SPPB_DOC_TYPE_BC16,
} from '../../constant';
import SppbPage from './sppb.presentation';

const mapStateToProps = state => ({
  notificationOpen: state.uiWebUserMain.notificationDrawerOpen,
  dialogVisibility: state.uiSppb.dialogVisibility,
  uploading: state.uiSppb.uploading,
  selectedDocType: state.uiSppb.selectedDocType,
  message: state.uiSppb.message,
});

const onClearForm = (dispatch) => {
  dispatch(setSppbSelectedDocType(''));
  dispatch(reset(RXFORM_SPPB));
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAppear: () => {
    dispatch(setSppbInfoDialogVisibility(false));
    onClearForm(dispatch);
  },
  onClearPressed: () => {
    onClearForm(dispatch);
  },
  onClosePressed: () => {
    dispatch(setSppbInfoDialogVisibility(false));
  },
  onSelectedDocTypeChange: (option, selectedDocType) => {
    dispatch(setSppbSelectedDocType(option));
    if (selectedDocType !== option) {
      if (option === SPPB_DOC_TYPE_BC16) {
        dispatch(change(RXFORM_SPPB, RXFIELD_SPPB_DOC_CODE, '41'));
      } else {
        dispatch(change(RXFORM_SPPB, RXFIELD_SPPB_DOC_CODE, ''));
      }
      dispatch(change(RXFORM_SPPB, RXFIELD_SPPB_NPWP, ''));
    }
  },
  onSubmitPressed: async (values) => {
    try {
      await dispatch(uploadSppbAsync({
        ...values,
        [RXFIELD_SPPB_DATE]: moment(values[RXFIELD_SPPB_DATE])
          .format(MOMENT_DATE_API_FORMAT_STRING),
      }));
      onClearForm(dispatch);
    } catch (error) {
      dispatch(showErrorSnackbar(LocalizedString.common.alertTitleError, error.message));
      unauthorizedErrorHandler(error, ownProps.history.push);
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SppbPage);
